import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    height: '70px',
    '& img': {
      width: '30px'
    },
    borderBottom: `${theme.palette.grey.grey200} 2px solid`,
  },
  title: {
    color: theme.palette.grey.grey800,
    fontSize: '25px',
    fontWeight: 600,
    marginLeft: '5px'
  },
  tpResultInfos: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: '30px',
    border: `${theme.palette.grey.grey100} 1px solid`,
    padding: '5px',
    borderRadius: '12px'
  },
  tpName: {
    color: theme.palette.primary.primary500,
    fontSize: '16px',
    fontWeight: 600,
    maxWidth: '160px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tpActivity: {
    fontSize: '10px',
    color: theme.palette.grey.grey700,
    fontWeight: 700,
    maxWidth: '160px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
